import { __awaiter, __generator } from "tslib";
import { getCaptcha, initCaptcha } from '@ekuaibao/auth';
import { app } from '@ekuaibao/whispered';
var isNonEmptyString = function (value) {
    return typeof value === 'string' && value.trim().length > 0;
};
export var getCaptchaProvider = function () {
    var _a;
    try {
        var featbit = app.require('@lib/featbit');
        return ((_a = featbit === null || featbit === void 0 ? void 0 : featbit.useAliyunCaptcha) === null || _a === void 0 ? void 0 : _a.call(featbit)) ? 'aliyun' : 'tencent';
    }
    catch (_b) {
        return 'tencent';
    }
};
export var preloadMachineCaptcha = function () {
    initCaptcha({ provider: getCaptchaProvider() });
};
var formatCaptchaData = function (captchaData, platform) {
    if (!captchaData || typeof captchaData !== 'object') {
        throw new Error('Invalid captcha proof');
    }
    var proof = captchaData;
    if (proof.provider === 'aliyun') {
        if (!isNonEmptyString(proof.captchaVerifyParam) || !isNonEmptyString(proof.sceneId)) {
            throw new Error('Invalid captcha proof');
        }
        return {
            platform: platform,
            aliVerifyParam: proof.captchaVerifyParam,
            aliSceneId: proof.sceneId,
        };
    }
    if (proof.provider === 'tencent') {
        if (!isNonEmptyString(proof.randstr) || !isNonEmptyString(proof.ticket)) {
            throw new Error('Invalid captcha proof');
        }
        return {
            platform: platform,
            txRandStr: proof.randstr,
            txTicket: proof.ticket,
        };
    }
    throw new Error('Unsupported captcha provider');
};
export var getMachineCaptchaPayload = function (platform) { return __awaiter(void 0, void 0, Promise, function () {
    var proof;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getCaptcha()];
            case 1:
                proof = _a.sent();
                return [2 /*return*/, formatCaptchaData(proof, platform)];
        }
    });
}); };
